export enum Roles {
  Admin = 'ROLE_ADMIN',
  ServiceDesk = 'ROLE_SERVICE_DESK',
  NarrowViewer = 'ROLE_BROWSER',
  WideViewer = 'ROLE_WIDE_BROWSER',
  Editor = 'ROLE_EDITOR',
  Shelter = 'ROLE_ANIMAL_SHELTER',
}
